import ClienteConsultFormPf from '@/features/client/components/consulta-cliente-pf'

export function CadastrarClientePagePf() {
  return <ClienteConsultFormPf />
}
